// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"_93444fe79c--checkbox-group--hS_2O"};